import React from 'react';
import { Provider as ReduxProvider } from 'react-redux';
import createStore from 'store/createStore';
import AppProvider from 'store/provider';
import wrapPageElementWithTransition from './helpers/wrapPageElement';
import { Theme } from './themes';

// React Context in Browser
// eslint-disable-next-line react/prop-types
const wrapRootElement = ({ element }) => {
  const store = createStore();
  return (
    <ReduxProvider store={store}>
      <AppProvider>
        <Theme>{element}</Theme>
      </AppProvider>
    </ReduxProvider>
  );
};

export default wrapRootElement;

// Page Transitions
export const wrapPageElement = wrapPageElementWithTransition;
